import { render, staticRenderFns } from "./create-sensor-dialog.component.vue?vue&type=template&id=53c903fc"
import script from "./create-sensor-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./create-sensor-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports